<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="3">
              <SelectEmpresa @onChanged="empresas = $event" :multiple="true" />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <SelectColaborador
                v-show="!todosColaboradores"
                :multiple="true"
                :empresas="empresas"
                @onChanged="colaboradores = $event"
              />
            </v-col>

            <v-col cols="12">
              <v-checkbox
                v-model="todosColaboradores"
                label="Para todos vendedores"
                color="blue darken-2"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <SelectCampanha :empresas="empresas" @onChanged="campanha = $event" />
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>

            <template v-if="!todosColaboradores">
              <v-col cols="12" v-for="(colaborador, i) in colaboradores" :key="i">
                <v-card>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <span style="font-weight: bold; font-size: 11pt">{{ colaborador.nome }}</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <input
                          ref="inputVideoFile"
                          type="file"
                          accept="video/*"
                          @change="addVideoFile(i, colaborador.cpf)"
                          style="display: none"
                        />
                        <v-btn
                          color="blue darken-2"
                          :title="colaborador.nome"
                          rounded
                          outlined
                          dark
                          small
                          @click="$refs.inputVideoFile[i].click()"
                        >
                          <v-icon left>mdi-video</v-icon>Adicionar Video
                        </v-btn>
                        <span>{{ getNameVideo(colaborador.cpf) }}</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>

            <v-col v-if="todosColaboradores">
              <input
                ref="inputVideoFileAll"
                type="file"
                accept="video/*"
                @change="addVideoFile(0, 'all')"
                style="display: none"
              />
              <v-btn
                color="blue darken-2"
                title="Adicionar Video"
                rounded
                outlined
                dark
                small
                @click="$refs.inputVideoFileAll.click()"
              >
                <v-icon left>mdi-video</v-icon>Adicionar Video
              </v-btn>
              <span>{{ getNameVideo('all') }}</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row dense>
            <v-col cols="12" align="center">
              <v-btn
                v-if="Object.keys(videosFiles).length > 0"
                color="blue darken-2"
                rounded
                outlined
                dark
                small
                @click="sendVideos()"
              >
                <v-icon left>mdi-upload</v-icon>
                Enviar {{ todosColaboradores ? ' Video' : ' Videos' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Arquivos } from "@/services/materiais";

export default {
  name: "VideoUpload",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectColaborador: () => import("@/components/select/SelectColaborador"),
    SelectCampanha: () => import("@/components/select/SelectCampanha")
  },

  data() {
    return {
      empresas: [],
      colaboradores: [],
      campanha: "",

      todosColaboradores: true,

      videosFiles: new Object()
    };
  },

  methods: {
    addVideoFile(index, cpf) {
      let file =
        cpf != "all"
          ? this.$refs.inputVideoFile[index].files[0]
          : this.$refs.inputVideoFileAll.files[0];

      if (cpf == "all") {
        this.videosFiles = new Object();
      }
      this.videosFiles[cpf] = file;
      this.$forceUpdate();
    },

    getNameVideo(cpf) {
      let file = this.videosFiles[cpf];
      return file ? file.name : "";
    },

    async sendVideoAllColaboradores() {
      let descricao = await this.$swal.inputText(
        "Descrição para o video",
        true,
        "Descrição"
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição do video");
        return;
      }

      try {
        this.$loading.setLoading(true, "Enviando para todos vendedores");

        for (const empresa of this.empresas) {
          await new Arquivos().uploadVideoByColaborador(
            empresa,
            "public",
            this.campanha,
            descricao,
            this.videosFiles["all"]
          );
        }

        this.$swal.success("Video enviado com sucesso");
        this.videosFiles = new Object();
      } catch (error) {
        console.error(error);
        this.$swal.error(`Erro ao enviar video: ${JSON.stringify(error)}`);
      } finally {
        this.$loading.setLoading(false);
        this.mensagem();
      }
    },

    async sendVideoByColaborador() {
      let descricao = await this.$swal.inputText(
        "Descrição para o video",
        true,
        "Descrição"
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição do video");
        return;
      }

      try {
        for (let empresa of this.empresas) {
          const colaboradoresDaEmpresa = this.colaboradores
            .map(colaborador =>
              colaborador.empresas.indexOf(empresa) >= 0 ? colaborador : ""
            )
            .filter(colaborador => colaborador !== "");

          if (colaboradoresDaEmpresa.length > 0) {
            for (const colaborador of colaboradoresDaEmpresa) {
              this.$loading.setLoading(
                true,
                `Enviando video do vendedor: ${colaborador.nome}`
              );
              await new Arquivos().uploadVideoByColaborador(
                empresa,
                colaborador.cpf,
                this.campanha,
                descricao,
                this.videosFiles[colaborador.cpf]
              );
            }
          }
        }

        this.$swal.success("Videos enviados com sucesso");
        this.videosFiles = new Object();
      } catch (error) {
        console.error(error);
        this.$swal.error(`Erro ao enviar video: ${JSON.stringify(error)}`);
      } finally {
        this.$loading.setLoading(false);
        this.mensagem();
      }
    },

    sendVideos() {
      if (!this.campanha) {
        this.$toast.warning("Selecione uma campanha");
        return;
      }

      if (this.todosColaboradores) this.sendVideoAllColaboradores();
      else this.sendVideoByColaborador();
    },

    async mensagem(){
      let confirm = await this.$swal.confirm("Deseja notificar os colaboradores a disponibilidade do novo material?");
      console.log("confirm", confirm);
      if(confirm){
        this.$router.push("/notificacao")
      }
    }
  },

  watch: {
    todosColaboradores() {
      this.videosFiles = new Object();
    }
  }
};
</script>
